import React from "react";
import ContentCard from "../../Cards/ContentCard/ContentCard";
import MaskGradientCard from "../../Pages/Podcast/MaskGradientCard";
import Button, { ButtonTypes } from "../../Button/Button";
import { SocialMedia } from "../../ShareOnSocialMedia/ShareOnSocialMedia";
import ShareOnSocialMedia from "../../ShareOnSocialMedia/ShareOnSocialMedia";
import { MaskType } from "../../MaskShapeContainer/MaskShapeContainer";

export interface IPodcastCard {
    image: string;
    topTagText?: string;
    topTagColor?: string;
    imageHeight?: string; // Relative to card's total height. Recommended to use percentages. e.g. h-[60%]
    textHeight?: string; // Relative to card's total height. Recommended to use percentages. e.g. h-[50%]
    gradient?: string;
    svg?: React.ReactNode;
    audioUrl?:string;
    title?: string;
    description?: string;
    onDownload?: () => void
}

const PodcastCard = ({
    image,
    topTagText,
    topTagColor,
    imageHeight = "h-[60%]",
    textHeight = "h-[50%]",
    gradient,
    svg,
    audioUrl,
    title = '',
    description = '',
    onDownload
}: IPodcastCard) => {
    const socialMedia: SocialMedia[] = [
        SocialMedia.Facebook,
        SocialMedia.Twitter,
        SocialMedia.Linkedin,
    ];
    const url = typeof window !== 'undefined' ? window.location.href : '';
    return (
        <ContentCard
            imageContent={
            <>
                 <MaskGradientCard
                            gradient={gradient}
                            svg={svg}
                            image={image}
                        />
                        {topTagText && topTagColor && (
                            <div className=" absolute top-0 right-0 flex flex-row-reverse px-4">
                                <div
                                    className={`${topTagColor} w-fit h-fit rounded-b-[0.625rem] py-4 px-3 font-ztGraftonRegular text-mobile-subtitle3 md:text-desktop-subtitle3 text-white uppercase`}
                                >
                                    {topTagText}
                                </div>
                            </div>
                        )}
                </>
            }
            textContent={
                <div className="absolute -top-3 h-full w-full flex flex-col justify-between px-6">
                    <div className="w-full pt-10 flex flex-col justify-center items-center">
                        <iframe
                            title="Libsyn Player"
                            src={`//html5-player.libsyn.com/embed/episode/id/${audioUrl}/height/80/theme/custom/thumbnail/no/direction/forward/render-playlist/no/custom-color/24135F`}
                            height="40%"
                            width='100%'
                            scrolling="no"
                            allowFullScreen
                        ></iframe>
                        <Button
                            title="Download Transcription"
                            buttonType={ButtonTypes.Principal}
                            className="w-full mb-2"
                            onClick={() => { onDownload?.() }}
                        />
                        <p className="subtitle-3 text-deep-blue self-start mb-2">Share this content</p>
                        <div className="flex flex-row mx-auto justify-center gap-x-8 w-[70%] h-auto">
                            <ShareOnSocialMedia
                                socialMedia={socialMedia}
                                iconColor="#24135F"
                                bgColor="bg-[#24135F40]"
                                url={url}
                                title={title}
                                description={description}
                            />
                        </div>
                    </div>
                </div>
            }
            textContentBackground="bg-white"
            imageContentStyle={imageHeight}
            textContentStyle={textHeight}
            maskType={MaskType.TopBulge}
            className="overflow-hidden rounded-[1.25rem]"
        />
    );
};

export default PodcastCard;
